import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconTaskAlert = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="yfm-icon yfm-icon-task-alert"
      {...omit(props, ["className"])}
      ref={ref}
    >
      <g clipPath="url(#clip0_2057_339)">
        <path
          d="M5.99975 0C2.68617 0 0 2.68617 0 5.99975C0 9.31333 2.68617 11.9995 5.99975 11.9995C9.31326 11.9995 11.9995 9.31333 11.9995 5.99975C11.9995 2.68617 9.31326 0 5.99975 0ZM7.62321 9.36703C7.27035 9.48897 6.99308 9.58301 6.78204 9.64969C6.57392 9.71629 6.32958 9.74958 6.05232 9.74958C5.62716 9.74958 5.2953 9.65516 5.06026 9.47209C4.82199 9.28354 4.7044 9.05076 4.7044 8.76224C4.7044 8.65132 4.71339 8.54033 4.73132 8.42393C4.74969 8.30754 4.77962 8.17427 4.816 8.02997L5.256 6.63766C5.2953 6.50476 5.27303 6.38282 5.30039 6.26057C5.32754 6.14418 5.33946 6.03325 5.33946 5.93913C5.33946 5.75576 5.35626 5.63382 5.27467 5.56714C5.19007 5.49507 5.03663 5.51577 4.80429 5.51577C4.6894 5.51577 4.57188 5.53227 4.45443 5.56002C4.33384 5.59339 4.23139 5.56714 4.14679 5.60051L4.26468 5.16779C4.55094 5.06234 4.8282 4.9737 5.09085 4.90155C5.35327 4.82399 5.60323 4.7907 5.83557 4.7907C6.26066 4.7907 6.58667 4.87958 6.81563 5.06264C7.04474 5.24571 7.29808 5.48405 7.29808 5.77256C7.29808 5.83368 7.28871 5.93913 7.2737 6.09438C7.25877 6.24407 7.22848 6.38282 7.18619 6.51023L6.60729 7.89679C6.57392 8.00772 6.54099 8.13543 6.5137 8.27973C6.48339 8.41847 6.46847 8.52938 6.46847 8.60147C6.46847 8.78454 6.51669 8.91195 6.60729 8.97862C6.70082 9.04493 6.86063 9.07822 7.0866 9.07822C7.1922 9.07822 7.31301 9.06172 7.44845 9.02872C7.58397 8.99541 7.68049 8.96759 7.74079 8.93977L7.62321 9.36703ZM7.54498 3.74219C7.34295 3.91424 7.09597 3.99733 6.80942 3.99733C6.52307 3.99733 6.27574 3.91424 6.06755 3.74219C5.86251 3.57563 5.76007 3.37059 5.76007 3.1264C5.76007 2.88769 5.86251 2.68234 6.06755 2.51061C6.27574 2.33886 6.52309 2.24991 6.80942 2.24991C7.0956 2.24991 7.34295 2.33849 7.54498 2.51061C7.75002 2.68265 7.8527 2.88806 7.8527 3.1264C7.8527 3.37058 7.75002 3.57563 7.54498 3.74219Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2057_339">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
);

IconTaskAlert.displayName = "IconTaskAlert";

export default IconTaskAlert;
